/**
 * Exportação das telas de Suprimentos — Bloco 1 do ADR-0061.
 *
 * Nenhuma tela do módulo tinha export. Contador pedindo posição de
 * estoque, gestor querendo conferir compras no Excel, inventário de fim
 * de ano — tudo saía por print de tela ou não saía.
 *
 * Converte o payload de cada endpoint para o shape `{titulo, resumo,
 * secoes}` que `salvarPDF`/`salvarExcel`/`salvarCSV` já consomem, no
 * mesmo padrão dos relatórios financeiros.
 */

import { salvarCSV, salvarExcel, salvarPDF } from "../../../utils/exportacao";
import { formatarDataLocal } from "../../../utils/dinheiro";

const SAVERS = { pdf: salvarPDF, excel: salvarExcel, csv: salvarCSV };

function despachar(formato, shape) {
  const saver = SAVERS[formato];
  if (!saver) throw new Error(`Formato desconhecido: ${formato}`);
  return saver(shape);
}

const num = (v) => (v == null || v === "" ? "0" : String(v));

/** Posição de estoque: o que o contador pede no fim do ano. */
export function exportarProdutos(formato, produtos, { filtro } = {}) {
  const linhas = (produtos || []).map((p) => ({
    Código: p.codigo || "",
    Nome: p.nome || "",
    Categoria: p.categoria_display || p.categoria || "",
    Unidade: p.unidade || "",
    Saldo: num(p.saldo),
    "Estoque mínimo": num(p.estoque_minimo),
    "Custo médio": num(p.custo_medio),
    Situação: p.ativo ? "Ativo" : "Inativo",
  }));
  return despachar(formato, {
    titulo: "Posição de estoque",
    resumo: [
      { rotulo: "Itens", valor: String(linhas.length) },
      { rotulo: "Filtro", valor: filtro || "todos" },
      { rotulo: "Gerado em", valor: formatarDataLocal(new Date()) },
    ],
    secoes: [{ titulo: "Materiais", linhas }],
  });
}

/** Razão de movimentos — a trilha de quem mexeu no saldo. */
export function exportarMovimentos(formato, movimentos, { periodo } = {}) {
  const linhas = (movimentos || []).map((m) => ({
    Data: m.created_at ? formatarDataLocal(m.created_at) : "",
    Produto: m.produto_nome || "",
    Tipo: m.tipo || "",
    Origem: m.origem_display || m.origem || "",
    Quantidade: num(m.quantidade),
    Observação: m.observacao || "",
  }));
  return despachar(formato, {
    titulo: "Movimentos de estoque",
    resumo: [
      { rotulo: "Lançamentos", valor: String(linhas.length) },
      { rotulo: "Período", valor: periodo || "todos" },
    ],
    secoes: [{ titulo: "Razão", linhas }],
  });
}

/** Ordens de compra — para conferir com o financeiro. */
export function exportarOrdensCompra(formato, ordens) {
  const linhas = (ordens || []).map((o) => ({
    Número: o.numero || "",
    Fornecedor: o.fornecedor_nome || "",
    Situação: o.situacao_display || o.situacao || "",
    "Prazo de entrega": o.prazo_entrega
      ? formatarDataLocal(o.prazo_entrega) : "",
    Valor: num(o.valor_total),
  }));
  return despachar(formato, {
    titulo: "Ordens de compra",
    resumo: [{ rotulo: "Ordens", valor: String(linhas.length) }],
    secoes: [{ titulo: "Compras", linhas }],
  });
}
